var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhoneBlack16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F4E21020-BFD7-4ACE-904A-52BC0F87FFCC_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-784.000000, -566.000000)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(752.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7028949,11.776 L12.8328949,8.906999 C12.4368949,8.509999 11.7938949,8.509999 11.3978949,8.906999 L9.45689489,10.847 C8.46389489,10.081 8.11389489,9.927 7.09289489,8.906999 C6.07089489,7.886 5.92189489,7.532 5.16189489,6.534 L7.09289489,4.602 C7.48989489,4.206 7.48989489,3.563 7.09289489,3.167 L4.22389489,0.297 C3.82789489,-0.099 3.18489489,-0.099 2.78789489,0.297 C2.78789489,0.297 -0.902104907,3.988 0.276895193,2.809 C-0.713104807,3.799 0.976894893,7.098 4.94089589,11.059 C8.90289489,15.0219999 12.2008949,16.7130009 13.1908949,15.7229992 C13.8478949,15.0659996 15.7028949,13.210999 15.7028949,13.210999 C16.0998949,12.815 16.0998949,12.173 15.7028949,11.776 Z M3.14689489,5.678 L2.06989489,3.884 L3.50589489,2.45 L4.94189489,3.885 L3.14689489,5.678 Z M12.1148949,13.929 L10.3218949,12.852999 L12.1148949,11.059 L13.5498949,12.495 L12.1148949,13.929 Z",
    id: "Icon_Phone_Gray-16px"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneBlack16Px);
export default __webpack_public_path__ + "static/media/Icon_Phone_Black-16px.e2fdf7b81bbfc214543ddba92eb7b637.svg";
export { ForwardRef as ReactComponent };